export default __webpack_public_path__ + "static/media/x20_log.154121e7.png";